import Menu from './menu';

class DDi {
  /**
   * Sets necessary variables for this class
   * that are used throughout
   */
  constructor() {
    this.menu = new Menu();
  }

  /**
   * Initializes all needed functions
   */
  init() {
    const homeSlider = $('.home-slider-items').owlCarousel({
      items: 1,
      animateIn: 'bounceInRight',
      animateOut: 'bounceOutLeft',
      mouseDrag: false,
      touchDrag: false,
      dots: false,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      onInitialized: () => {
        setTimeout(() => {
          homeSlider.trigger('refresh.owl.carousel');
        }, 1);
      },

      // Reverse animations aren't merged yet
      // https://github.com/OwlCarousel2/OwlCarousel2/pull/2217
      // Possible solution is to copy that class and set it in this theme
      backAnimateIn: 'bounceInLeft',
      backAnimateOut: 'bounceOutRight',
    });

    let sliderMarkers = $('.home-slider-markers');
    if ($(window).width() < 768) {
      sliderMarkers.addClass('owl-carousel');
      sliderMarkers = sliderMarkers.owlCarousel({
        items: 4,
        center: true,
        dots: false,
      });
    }

    const recentPostsSlider = $('.recent-posts-slider-wrap.owl-carousel').owlCarousel({
      items: 1,
      margin: 15,
      onInitialized: () => {
        setTimeout(() => {
          recentPostsSlider.trigger('refresh.owl.carousel');
        }, 1);
      },
    });

    $('.image-carousel.owl-carousel').owlCarousel({
      items: 3,
      autoplay: true,
      slideBy: 'page',
      responsive: {
        768: {
          items: 6,
        },
      },
    });

    // Fix autoplay timer after user interaction
    $('.image-carousel.owl-carousel').on('touchstart', 'img', function triggerStop() {
      $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
    });
    $('.image-carousel.owl-carousel').on('touchend', 'img', function triggerPlay() {
      $(this).closest('.owl-carousel').trigger('play.owl.autoplay');
    });
    $('.image-carousel.owl-carousel').on('click', '.owl-dots, .owl-nav', function triggerReset() {
      $(this).closest('.owl-carousel').trigger('stop.owl.autoplay');
      $(this).closest('.owl-carousel').trigger('play.owl.autoplay');
    });
  
    // Marker click
    // $('.home-slider-markers .marker').on('click', (event) => {
    //   const marker = $(event.currentTarget);
    //   const index = marker.data('slide-index');

    //   if (!marker.hasClass('active-marker')) {
    //     this.homeSliderSlideTo(index);
    //   }
    // });

    sliderMarkers.on('dragged.owl.carousel', event => this.homeSliderSlideTo(event.item.index));

    this.homeSlider = homeSlider;
    this.sliderMarkers = sliderMarkers;

    homeSlider.on('changed.owl.carousel', (event) => {
      if (event.item.index === null) {
        return;
      }
      
      // Loop option has a problem with indexes, this fixes it
      const index = DDi.fixOwlCurrentIdx(event);

      // Resets autoplay timer on user interaction
      homeSlider.trigger('stop.owl.autoplay');
      homeSlider.trigger('play.owl.autoplay');

      sliderMarkers.trigger('to.owl.carousel', [index]);

      $('.home-slider-markers .active-marker').removeClass('active-marker');
      $(`.home-slider-markers .marker[data-slide-index=${index}]`).addClass('active-marker');
    });
  }

  static fixOwlCurrentIdx(event) {
    /* eslint-disable no-underscore-dangle */
    let current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
    /* eslint-enable no-underscore-dangle */
    const itemsCount = event.item.count;
  
    if (current > itemsCount || current === 0) {
      current = itemsCount - (current % itemsCount);
    }
    
    return current - 1;
  }

  homeSliderSlideTo(index) {
    $('.home-slider-markers .active-marker').removeClass('active-marker');
    $(`.home-slider-markers .marker[data-slide-index=${index}]`).addClass('active-marker');

    this.sliderMarkers.trigger('to.owl.carousel', [index]);
    this.homeSlider.trigger('to.owl.carousel', [index]);
    this.homeSlider.trigger('refresh.owl.carousel');

    const description = `.home-slider-items .owl-item:nth-child(${index + 1}) .slider-description`;
    DDi.animateCSS(description, 'bounceInRight');
  }

  static animateCSS(element, animationName, callback) {
    const node = document.querySelector(element);
    node.classList.add('animated', animationName);

    function handleAnimationEnd() {
      node.classList.remove('animated', 'owl-animated-in', 'owl-animated-out', animationName);
      node.removeEventListener('animationend', handleAnimationEnd);

      if (typeof callback === 'function') callback();
    }

    node.addEventListener('animationend', handleAnimationEnd);
  }
}

$(() => {
  new DDi().init();
});
